import React, { Fragment } from 'react';

/**
 * 카드 중복할인 컴포넌트
 */
function CardDuplicateDiscount({ cardInfo, cardDuplicateDiscountInfos }) {
  const representative = cardInfo[cardDuplicateDiscountInfos.representative];
  const discountVolume = TMON.util.numberWithComma(
    cardDuplicateDiscountInfos.maxCardDiscountItem.discountVolume
  );
  const cardDuplicateDiscountUnit =
    cardDuplicateDiscountInfos.discountType === 'AMOUNT' ? '원' : '%';
  const cardDuplicateDiscountPrice = TMON.util.numberWithComma(
    cardDuplicateDiscountInfos.cardDuplicateDiscountPrice
  );

  return (
    <p>
      {representative}카드 결제 시
      {cardDuplicateDiscountInfos.cardDuplicateDiscountPrice > 0 ? (
        <Fragment>
          {' '}
          {discountVolume}
          {cardDuplicateDiscountUnit} 중복할인가
          <span className="text_color2"> {cardDuplicateDiscountPrice}원</span>
        </Fragment>
      ) : (
        <Fragment>
          {' '}
          최대{' '}
          <span className="text_color2">
            {discountVolume}
            {cardDuplicateDiscountUnit}
          </span>{' '}
          중복할인
        </Fragment>
      )}
    </p>
  );
}

export default CardDuplicateDiscount;
